import React from 'react';

import strings from '../../../Localization/Localization';

import MainLayout from '../../Layout/MainLayout';

import { withModalHandler } from '../../../HOC/ModalHandler';

import { connect } from 'react-redux';
import { addBreadcrumbAction } from '../../../Store/Action/breadcrumb';

import { withRouter } from 'react-router-dom';

import { getYousignFromId } from '../../../API/Quotes';

import YousignV2 from '../V2/Sign';
import YousignV3 from '../V3/Sign';

import Loading from '../../Layout/Loading';

// import { quotes as routes } from '../../../MetaData/Route/routes';

/**
 * YousignQuote
 */
class YousignQuote extends React.Component {

  constructor(props) {
    super(props);

    this.getQuote = this.props.modalHandler.addVerificationWithCallback(getYousignFromId, this.postGet);

    this.state = {
      loading: true,
      quote: null
    }
  }

  componentDidMount() {
    this.getQuote(this.props.match.params.id);

    this.props.dispatch(addBreadcrumbAction(window.location.pathname, strings.yousign.quote.breadcrumb));
  }

  postGet = (data) => {
    this.setState({
      quote: data.item,
      loading: false
    })
  }

  displayProcedure() {
    if(this.state.loading === false && this.state.quote["yousign_procedure"] && this.state.quote["yousign_procedure"]["uuid"]) {
      return (
        <YousignV2 procedure={this.state.quote.yousign_procedure}/>
      )
    }
  }

  displaySignatureRequest() {
    if(this.state.loading === false && this.state.quote["yousign_signature_request"] && this.state.quote["yousign_signature_request"]["uuid"]) {
      return (
        <YousignV3 signatureRequest={this.state.quote["yousign_signature_request"]}/>
      )
    }
  }

  displayLoading() {
    if(this.state.loading) {
      return (
        <Loading/>
      )
    }
  }

  /**
   * Main render method for React Component
   */
  render() {
    return (
      <MainLayout>
        {this.displayLoading()}
        {this.displayProcedure()}
        {this.displaySignatureRequest()}
      </MainLayout>
    );
  }
}

export default connect()(withRouter(withModalHandler(YousignQuote)));
